/** Note client / particularité saisie à la réservation (champ RDV `notes`). */

export function rdvClientNoteText(rdv) {
  return String(rdv?.notes || '').trim();
}

export function rdvHasClientParticularity(rdv) {
  return rdvClientNoteText(rdv).length > 0;
}
